import React, { FunctionComponent, DetailedHTMLProps, HTMLAttributes } from 'react'
import ProductCart from '../Icons/ProductCart'
import styles from './cartIcon.module.scss'
import clsx from 'clsx'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  count?: number
  isRedesign?: boolean
  isExpanded?: boolean
}

const CartIcon: FunctionComponent<Props> = ({ count, isRedesign, isExpanded, ...rest }) => (
  <div {...rest} data-testid="cart-icon">
    {!!count && <span className={clsx(
          styles['cart-icon-indicator'],
          isExpanded && styles.expanded
        )}>{count}</span>}
    <ProductCart variant={isRedesign ? 'gray' : undefined} />
  </div>
)

export default CartIcon
